import ui_pwd_9141, {
  form_meta as ui_pwd_9141_meta,
  form_nav as ui_pwd_9141_nav,
} from "./PWD_9141/pwd_9141_ui";
import ui_cw1_9141C, {
  form_meta as ui_cw1_9141C_meta,
  form_nav as ui_cw1_9141C_nav,
} from "./CW-1_9141C/cw-1_9141C_ui";
// V3
import ui_h2a_790, {
  form_meta as ui_h2a_790_meta,
  form_nav as ui_h2a_790_nav,
} from "./H-2A_790/h-2a_790_ui";
// V2
import ui_h2a_790V2, {
  form_meta as ui_h2a_790V2_meta,
  form_nav as ui_h2a_790V2_nav,
  getSchemaWithState as getV2SchemaWithState,
} from "./H-2A_790V2/h-2a_790V2_ui";
import ui_h2a_9142A, {
  form_meta as ui_h2a_9142A_meta,
  form_nav as ui_h2a_9142A_nav,
} from "./H-2A_9142A/h-2a_9142A_ui";
import ui_h2a_9142A_V2, {
  form_meta as ui_h2a_9142A_meta_V2,
  form_nav as ui_h2a_9142A_nav_V2,
} from "./H-2A_9142A_V2/h-2a_9142A_ui";
import ui_h2b_9142B, {
  form_meta as ui_h2b_9142B_meta,
  form_nav as ui_h2b_9142B_nav,
} from "./H2B_9142B/h2b_9142B_ui";

import ui_cw1_9142C, {
  form_meta as ui_cw1_9142C_meta,
  form_nav as ui_cw1_9142C_nav,
} from "./CW-1_9142C/cw-1_9142C_ui";

import ui_eta_9035, {
  form_meta as ui_eta_9035_meta,
  form_nav as ui_eta_9035_nav,
} from "./LCA_9035/eta_9035_ui";

import ui_perm_9089, {
  form_meta as ui_perm_9089_meta,
  form_nav as ui_perm_9089_nav,
} from "./PERM_9089/perm_9089_ui";

import machine_name_lookup from "./generateMachineNameLookup";

import reuse_9141, {
  sectionTitles as sectionTitles_9141,
} from "./PWD_9141/pwd_9141_reuse";
// V3
import reuse_790a, {
  sectionTitles as sectionTitles_790a,
} from "./H-2A_790/h-2a_790_reuse";
// V2
import reuse_790aV2, {
  sectionTitlesV1 as sectionTitles_790aV1,
  sectionTitlesV2 as sectionTitles_790aV2,
} from "./H-2A_790V2/h-2a_790V2_reuse";
import reuse_9035, {
  sectionTitles as sectionTitles_9035,
} from "./LCA_9035/eta_9035_reuse";
import reuse_9089, {
  sectionTitles as sectionTitles_9089,
} from "./PERM_9089/perm_9089_reuse";

const UISchemaResolver = (formName, state) => {
  const uiSchemaList = {
    9141: ui_pwd_9141,
    "9141-meta": ui_pwd_9141_meta,
    "9141-nav": ui_pwd_9141_nav,
    "9141-lookup": machine_name_lookup(ui_pwd_9141),
    "9141-reuse": reuse_9141,
    "9141-reuse-sections": sectionTitles_9141,
    "9141C": ui_cw1_9141C,
    "9141C-meta": ui_cw1_9141C_meta,
    "9141C-nav": ui_cw1_9141C_nav,
    "9141C-lookup": machine_name_lookup(ui_cw1_9141C),
    9089: ui_perm_9089,
    "9089-meta": ui_perm_9089_meta,
    "9089-nav": ui_perm_9089_nav,
    "9089-lookup": machine_name_lookup(ui_perm_9089),
    "9089-reuse": reuse_9089,
    "9089-reuse-sections": sectionTitles_9089,
    // V3
    /* inject state for page6 meal rates see 790AV2 */
    "790A": ui_h2a_790,
    "790A-meta": ui_h2a_790_meta,
    "790A-nav": ui_h2a_790_nav,
    "790A-lookup": machine_name_lookup(ui_h2a_790),
    "790A-reuse": reuse_790a,
    "790A-reuse-sections": sectionTitles_790a,
    // V2
    "790AV2": state ? getV2SchemaWithState(state) : ui_h2a_790V2,
    "790AV2-meta": ui_h2a_790V2_meta,
    "790AV2-nav": ui_h2a_790V2_nav,
    "790AV2-lookup": machine_name_lookup(ui_h2a_790V2),
    "790AV2-reuse": reuse_790aV2,
    "790AV2-reuse-sections": sectionTitles_790aV2,
    "790AV1-reuse-sections": sectionTitles_790aV1,
    "9142A": ui_h2a_9142A,
    "9142A-meta": ui_h2a_9142A_meta,
    "9142A-nav": ui_h2a_9142A_nav,
    "9142A-lookup": machine_name_lookup(ui_h2a_9142A),
    "9142AV2": ui_h2a_9142A_V2,
    "9142AV2-meta": ui_h2a_9142A_meta_V2,
    "9142AV2-nav": ui_h2a_9142A_nav_V2,
    "9142AV2-lookup": machine_name_lookup(ui_h2a_9142A_V2),
    "9142B": ui_h2b_9142B,
    "9142B-meta": ui_h2b_9142B_meta,
    "9142B-nav": ui_h2b_9142B_nav,
    "9142B-lookup": machine_name_lookup(ui_h2b_9142B),
    "9142C": ui_cw1_9142C,
    "9142C-meta": ui_cw1_9142C_meta,
    "9142C-nav": ui_cw1_9142C_nav,
    "9142C-lookup": machine_name_lookup(ui_cw1_9142C),

    9035: ui_eta_9035,
    "9035-meta": ui_eta_9035_meta,
    "9035-nav": ui_eta_9035_nav,
    "9035-lookup": machine_name_lookup(ui_eta_9035),
    "9035-reuse": reuse_9035,
    "9035-reuse-sections": sectionTitles_9035,
  };
  return uiSchemaList[formName];
};

export default UISchemaResolver;
